import { serialize as defaultSerialize } from 'object-to-formdata'

export const serialize = (params) => defaultSerialize(params, { allowEmptyArrays: true })

export const constructCSVDataParam = (csvData, base_url) => `csv_data=${csvData}&base_url=${base_url}`
